import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const TransactionDetailPage = lazy(() => import('@/pages/transactions/detail'));

export const Route = createFileRoute('/transactions/$id')({
  component: function TransactionRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <TransactionDetailPage transactionId={id} />
      </Suspense>
    );
  },
});
